import { render, staticRenderFns } from "./FeeStatusReportPrint.vue?vue&type=template&id=bc56edfe&scoped=true&"
import script from "./FeeStatusReportPrint.vue?vue&type=script&lang=js&"
export * from "./FeeStatusReportPrint.vue?vue&type=script&lang=js&"
import style0 from "./FeeStatusReportPrint.vue?vue&type=style&index=0&id=bc56edfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc56edfe",
  null
  
)

export default component.exports